var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#FC243E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.584 17.375L12.584 14.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.416 17.375L16.416 14.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 9.7085H23.125V9.7085C22.3103 9.7085 21.903 9.7085 21.5762 9.82541C21.0124 10.0271 20.5686 10.4709 20.3669 11.0347C20.25 11.3615 20.25 11.7688 20.25 12.5835V18.1668C20.25 20.0524 20.25 20.9953 19.6642 21.581C19.0784 22.1668 18.1356 22.1668 16.25 22.1668H12.75C10.8644 22.1668 9.92157 22.1668 9.33579 21.581C8.75 20.9953 8.75 20.0524 8.75 18.1668V12.5835C8.75 11.7688 8.75 11.3615 8.63309 11.0347C8.43135 10.4709 7.9876 10.0271 7.42378 9.82541C7.09703 9.7085 6.68969 9.7085 5.875 9.7085V9.7085Z",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.648 6.23015C12.7572 6.12826 12.9978 6.03823 13.3326 5.97402C13.6673 5.90981 14.0774 5.875 14.4993 5.875C14.9213 5.875 15.3314 5.90981 15.6661 5.97402C16.0009 6.03823 16.2415 6.12826 16.3507 6.23015",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/deleteRed.7aff38c8f45df15ced753c940afa572f.svg";
export { ForwardRef as ReactComponent };